<template>
  <div class="tabs flex border-b mb-4">
    <button
      class="px-4 py-2 -mb-px font-semibold border-b-2"
      :class="{
        'border-custom-yellow text-custom-blue':
          currentTab === 'inventory-queue',
        'text-gray-500': currentTab !== 'inventory-queue',
      }"
      @click="currentTab = 'inventory-queue'"
    >
      Inventory Details
    </button>
    <button
      class="px-4 py-2 -mb-px font-semibold border-b-2"
      :class="{
        'border-custom-yellow text-custom-blue': currentTab === 'stock-queue',
        'text-gray-500': currentTab !== 'stock-queue',
      }"
      @click="currentTab = 'stock-queue'"
    >
      Stock Details
    </button>
  </div>
  <div class="flex justify-end space-x-4 mt-4 mb-4 sm:mt-0">
    <template v-if="currentTab === 'stock-queue'">
      <CustomButton
        label="Add Stock"
        :icon-path="'M5 12h14m-7 7V5'"
        @click="addStock"
        bg-class="bg-custom-yellow"
      />
      <CustomButton
        label="Upload Inventory Stock"
        :icon-path="'M5 12h14m-7 7V5'"
        bg-class="bg-custom-yellow"
        @click="handleUploadInventoryStocks"
      />
    </template>
  </div>
  <component
    :is="currentTabComponent"
    ref="currentTabComponent"
    :search-query="searchQuery"
    :inventoryItem="inventoryItem"
    :inventory_store_items="inventoryItem.inventory_store_items"
    @refresh="getInventoryItemDetails"
  ></component>

  <UploadInventoryStocksModal :show="showUploadInventoryStocks" @close="showUploadInventoryStocks = false" @upload-success="handleUploadSuccess" :inventoryItemCode="inventoryItem.code" />
</template>

<script>
import apiClient from "@/services/api";
import CustomButton from "@/components/CustomButton.vue";
import InventoryItemDetailsTab from "../tabs/inventory_tabs/InventoryItemDetailsTab.vue";
import InventoryItemStockDetailsTab from "../tabs/inventory_tabs/InventoryItemStockDetailsTab.vue";
import UploadInventoryStocksModal from "@/views/modals/inventory/UploadInventoryStocksModal.vue"

export default {
  name: "InventoryItemDetails",
  components: {
    CustomButton,
    InventoryItemDetailsTab,
    InventoryItemStockDetailsTab,
    UploadInventoryStocksModal
  },
  data() {
    return {
      inventoryItem: {},
      showLoader: false,
      currentTab: "inventory-queue",
      showUploadInventoryStocks: false
    };
  },
  mounted() {
    this.itemId = this.$route.params.id;
    this.getInventoryItemDetails();
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "inventory-queue":
          return "InventoryItemDetailsTab";
        case "stock-queue":
          return "InventoryItemStockDetailsTab";
        default:
          return "InventoryItemDetailsTab";
      }
    },
    activeTabClass() {
      return "inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active";
    },
    inactiveTabClass() {
      return "inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50";
    },
  },
  methods: {
    handleUploadInventoryStocks() {
      // Ensure inventory item code is available before showing modal
      if (this.inventoryItem && this.inventoryItem.code) {
        this.showUploadInventoryStocks = true;
      } else {
        this.$toast.error("Inventory item's details not fully loaded. Please try again!")
      }
    },

    async handleUploadSuccess() {
      await this.getInventoryItemDetails();
      this.currentTab = 'stock-queue'
    },

    getStatusStyle(status) {
      switch (status) {
        case "In Stock":
          return "bg-blue-50 text-custom-blue";
        case "Low Stock":
          return "bg-orange-50 text-custom-yellow";
        case "Out Of Stock":
          return "bg-red-50 text-red-500";
        default:
          return "bg-gray-50 text-gray-800";
      }
    },
    async getInventoryItemDetails() {
      try {
        this.showLoader = true;
        const response = await apiClient.getInventoryItem(this.itemId);

        if (response.success) {
          this.inventoryItem = response.data;
          this.showLoader = false;
        } else {
          this.showLoader = false;
          this.$toast.error("Unable to fetch inventory item details.");
        }
        this.showLoader = false;
      } catch (error) {
        console.log("error", error);
        this.$toast.error(
          "Unable to fetch inventory item, please check your internet connection."
        );
      }
    },
    addStock() {
      this.$router.push("/add-inventory-item-stock/" + this.inventoryItem.id);
    },
  },
};
</script>

<style scoped>
/* Optional: Add custom styling to improve spacing */
</style>
